import React from 'react';
import Card from '../ui/Card';
import { ConstructionIcon, ArrowRightIcon } from 'lucide-react';
interface PlaceholderPageProps {
  title: string;
  section: string;
}
const PlaceholderPage: React.FC<PlaceholderPageProps> = ({
  title,
  section
}) => {
  return <div data-id="element-8139">
      {/* Page Header */}
      <div className="mb-8" data-id="element-8140">
        <div className="flex items-center text-sm text-gray-500 mb-2" data-id="element-8141">
          <span data-id="element-8142">{section}</span>
          <ArrowRightIcon size={14} className="mx-2" data-id="element-8143" />
          <span className="text-gray-900 font-medium" data-id="element-8144">{title}</span>
        </div>
        <h1 className="text-3xl font-bold text-gray-900" data-id="element-8145">{title}</h1>
      </div>
      {/* Placeholder Content */}
      <Card className="p-12" data-id="element-8146">
        <div className="flex flex-col items-center justify-center text-center" data-id="element-8147">
          <div className="bg-blue-50 p-6 rounded-full mb-6" data-id="element-8148">
            <ConstructionIcon size={48} className="text-blue-600" data-id="element-8149" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-8150">
            Page Under Construction
          </h2>
          <p className="text-gray-600 mb-6 max-w-md" data-id="element-8151">
            This page is part of the comprehensive dashboard structure. Charts
            and analytics will be added in the next phase.
          </p>
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 max-w-2xl" data-id="element-8152">
            <h3 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-8153">
              Planned Features for {title}:
            </h3>
            <ul className="text-sm text-gray-600 space-y-2 text-left" data-id="element-8154">
              <li className="flex items-start" data-id="element-8155">
                <span className="text-blue-600 mr-2" data-id="element-8156">•</span>
                <span data-id="element-8157">Real-time KPI metrics with INR formatting</span>
              </li>
              <li className="flex items-start" data-id="element-8158">
                <span className="text-blue-600 mr-2" data-id="element-8159">•</span>
                <span data-id="element-8160">Interactive charts and visualizations</span>
              </li>
              <li className="flex items-start" data-id="element-8161">
                <span className="text-blue-600 mr-2" data-id="element-8162">•</span>
                <span data-id="element-8163">Drill-down capabilities for detailed analysis</span>
              </li>
              <li className="flex items-start" data-id="element-8164">
                <span className="text-blue-600 mr-2" data-id="element-8165">•</span>
                <span data-id="element-8166">Export functionality for reports</span>
              </li>
              <li className="flex items-start" data-id="element-8167">
                <span className="text-blue-600 mr-2" data-id="element-8168">•</span>
                <span data-id="element-8169">Cross-functional filters and comparisons</span>
              </li>
            </ul>
          </div>
        </div>
      </Card>
      {/* Additional Placeholder Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8" data-id="element-8170">
        <Card className="p-6" data-id="element-8171">
          <div className="h-48 bg-gray-100 rounded-lg flex items-center justify-center" data-id="element-8172">
            <span className="text-gray-400 text-sm" data-id="element-8173">Chart Placeholder 1</span>
          </div>
        </Card>
        <Card className="p-6" data-id="element-8174">
          <div className="h-48 bg-gray-100 rounded-lg flex items-center justify-center" data-id="element-8175">
            <span className="text-gray-400 text-sm" data-id="element-8176">Chart Placeholder 2</span>
          </div>
        </Card>
        <Card className="p-6" data-id="element-8177">
          <div className="h-48 bg-gray-100 rounded-lg flex items-center justify-center" data-id="element-8178">
            <span className="text-gray-400 text-sm" data-id="element-8179">Chart Placeholder 3</span>
          </div>
        </Card>
      </div>
    </div>;
};
export default PlaceholderPage;